import React, {useMemo} from "react";
import {useHtmlClassService} from "../../../core/AppLayout";
import {Switch, Route} from "react-router-dom";
import DefaultMenuList from "./DefaultMenuList";
import modulesRoutes from "../../../../routes/modules";

export function AsideMenu({disableScroll}) {
    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            asideMenuAttr: uiService.getAttributes("aside_menu"),
            ulClasses: uiService.getClasses("aside_menu_nav", true),
            asideClassesFromConfig: uiService.getClasses("aside_menu", true)
        };
    }, [uiService]);

    return (
        <>
            {/* begin::Menu Container */}
            <div id="od_aside_menu"
                 data-menu-vertical="1"
                 className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
                 {...layoutProps.asideMenuAttr}>
                <Switch>
                    {modulesRoutes.map((route, index) => (
                        <Route
                            key={index}
                            path={route.path}
                            exact={route.exact}
                            children={<route.menu layoutProps={layoutProps}/>}
                        />
                    ))}

                    <Route>
                        <DefaultMenuList layoutProps={layoutProps}/>
                    </Route>
                </Switch>
            </div>
            {/* end::Menu Container */}
        </>
    );
}
